import React, { useEffect, useState } from 'react';
import { CancelFailLineIcon, CheckSuccessIcon, PrimaryButton, VistraLoader } from '@tricor-digital-team/vistra-design-system';
import { useNavigate, useParams } from 'react-router-dom';
import { AxiosClient } from '../../../../Utils/AxiosClient';

const SubmissionComplete = () => {
  const navigate = useNavigate();

  const [paymentStatus, setPaymentStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  const { sessionId } = useParams();

  useEffect(() => {
    const checkPaymentStatus = async () => {
      if (!sessionId) {
        setPaymentStatus('paid');
        setLoading(false);
        return;
      }

      try {
        const response = await AxiosClient.get(`/verify/${sessionId}`);
        setPaymentStatus(response.data.status === 'paid' ? 'paid' : 'failed');
      } catch (error) {
        console.error('Payment check failed:', error);
        setPaymentStatus('failed');
      } finally {
        setLoading(false);
      }
    };

    checkPaymentStatus();
  }, [sessionId]);

  if (loading) {
    return (
      <div className="w-full mt-12 max-w-[807px] flex flex-col items-center justify-center">
        <div className="bg-white shadow-xl rounded-2xl w-full py-12 px-[103px]">
          <div className="h-[200px] flex items-center justify-center">
            <VistraLoader />
          </div>
        </div>
      </div>
    )
  }

  if (paymentStatus === 'failed') {
    return (
      <div className="w-full mt-12 max-w-[807px] flex flex-col items-center justify-center">
        <div className="bg-white shadow-xl rounded-2xl w-full py-12 px-[103px]">
          <CancelFailLineIcon className="text-[64px] text-red-600" />
          <div className="text-black text-4xl mt-6 font-normal">Submission failed!</div>
          <div className="text-black text-base mt-6 font-normal">
            Your payment was not successful. Please check your payment details and try again.
          </div>
          {/* <div className="text-black text-base mt-6">
            Make sure all individuals named in the application know that they’ll soon receive an email from{' '}
            <span className="text-blue-800 underline font-medium">no-reply@credas.com</span> If they don’t see it in
            their inbox, they should check their junk or spam folder.
          </div> */}
          <div className="text-black text-base mt-6">
            Need help? Contact the Vistra IDV team at{' '}
            <a href='mailto:identityverification@vistra.com' className="text-blue-800 underline font-medium">identityverification@vistra.com</a>.
          </div>
          <div className="mt-12">
            <PrimaryButton
              label="Try Again"
              onClick={(e) => {
                e.preventDefault();
                navigate('/');
              }}
              size="large"
            />
          </div>
        </div>
      </div>
    );
  }


  return (
    <div className="w-full mt-12 max-w-[807px] flex flex-col items-center justify-center">
      <div className="bg-white shadow-xl rounded-2xl w-full py-12 px-[103px]">
        <CheckSuccessIcon className="text-[64px] text-[#1C7D29]" />
        <div className="text-black text-4xl mt-6 font-normal">Submission complete!</div>
        <div className="text-black text-base mt-6 font-normal">
          Thank you for submitting your Companies House Verification Service application form. You'll get an email
          shortly with your application details and payment receipt.
        </div>
        <div className="text-black text-base mt-6">
          Make sure all individuals named in the application know that they’ll soon receive an email from{' '}
          <span className="text-blue-800 underline font-medium">no-reply@credas.com</span> If they don’t see it in
          their inbox, they should check their junk or spam folder.
        </div>
        <div className="text-black text-base mt-6">
          Need help? Contact the Vistra IDV team at{' '}
          <a href='mailto:identityverification@vistra.com' className="text-blue-800 underline font-medium">identityverification@vistra.com</a>
        </div>
        <div className="mt-12">
          <PrimaryButton
            label="Close"
            onClick={(e) => {
              e.preventDefault();
              navigate('/');
            }}
            size="large"
          />
        </div>
      </div>
    </div>
  );
};

export default SubmissionComplete;
